<template>
  <v-dialog width="80%" v-model="dialog" persistent @keydown.esc="done">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t("tests.test.testResult") }}</span>
        <v-spacer />
        <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="px-12">
        <v-row align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center">
              <v-col class="text-center">
                <v-icon color="success" size="75">check_circle_outline </v-icon>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="text-center">
                <span class="headline">{{ $t("validation.testCorrect") }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-12">
        <v-spacer />
        <v-btn color="primary" @click="$emit('ok')">{{ actionText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["show", "actionText"],
  data() {
    return {};
  },
  computed: {
    dialog() {
      return this.show;
    },
  },
};
</script>